'use client';
/**
 * Выполняет проверку того, что `subject` является `boolean`.
 *
 * @remarks
 * Type-guard обёртка над `typeof`.
 *
 * @param subject - Субъект проверки произвольного типа.
 *
 * @stable
 * */ var isBoolean = function(subject) {
    return typeof subject === "boolean";
};

export { isBoolean };
